import { ReadingData } from "../index";
import monitorApi from "../api";
import monitorWs from "../ws";
import { ref } from "vue";
import readingApi from "../reading/api";
import { Observable } from "rxjs";
import { Log } from "../log";
import logBloc from "../log/bloc";
import environment from "@/config";
import storage from "@/storage";
import { ISiteStorage, IUserStorage } from "@/storage/model";

export abstract class BaseMonitorBloc {
  module = "monitor";
  ws = monitorWs;
  api = monitorApi;
  context = ref([]);
  base_url = environment.API_URL + "/" + module;
  log_url = logBloc.base_url;

  async getReadings(id: any, params = {}): Promise<ReadingData[]> {
    let response = await readingApi.allByEquipment(id, params);
    if (response.data)
      return response.data.map((data) => ({ ...data, id: data.sensor_id }));
    return response.data;
  }

  async getOneMinBy30min(
    sensor_id: string,
    timestamp: string
  ): Promise<ReadingData[]> {
    let response = await readingApi.getOneMinBy30min(sensor_id, timestamp);
    if (response.data)
      return response.data.map((data) => ({ ...data, id: data.sensor_id }));
    return response.data;
  }

  async listenReadings30m(
    userId: string,
    equipmentId: string
  ): Promise<Observable<ReadingData>> {
    return await this.ws.listen(userId, "cems-30m-" + equipmentId);
  }

  async listenReadings1s(
    userId: string,
    equipmentId: string
  ): Promise<Observable<ReadingData>> {
    return await this.ws.listen(userId, "cems-1s-" + equipmentId);
  }

  async listenAlarm(userId: string, siteId: string): Promise<Observable<Log>> {
    return await this.ws.listen(userId, "cems-alarm-" + siteId);
  }

  async getLogs(id: string): Promise<Log[]> {
    let response = await this.api.logAll(id);
    return response.data.data;
  }

  async getUserStorage(): Promise<IUserStorage> {
    return storage.get<IUserStorage>(storage.LOGIN_TOKEN);
  }

  async getSiteStorage(): Promise<ISiteStorage> {
    return storage.get<ISiteStorage>(storage.SITE);
  }

  // FIXME: not working
  async destroyMonitor(id: any): Promise<void> {
    let response = await readingApi.destroy(id);
    return response.data;
  }

  stopReadings(): void {
    this.ws?.disconnect();
  }

  async getEquipment(id: string): Promise<string> {
    const params = {
      with: "customField"
    }
    return await this.api.getEquipment(id, params);
  }

  async getEquipments(params: any = {}): Promise<string> {
    params.orderBy = {
      created_at: "asc"
    };
    return await this.api.getEquipments(params);
  }

  async getEquipmentsUrlBySite(): Promise<string> {
    const site = await this.getSiteStorage();
    const params = {
      search: {
        advanced: {
          site_id: site.id,
        },
      },
    };
    return this.api.getUrl("/equipment", params);
  }

  getLogUrlByEquipment(equipmentId: string): string {
    const params = {
      search: {
        advanced: {
          equipment_id: equipmentId,
        },
      },
    };
    return this.api.getUrl(`/log`, params);
  }

  async getSensorByEquipment(equipment_id: any): Promise<any> {
    let response = await this.api.byEquipment(equipment_id);
    return response.data;
  }

  isActive(last_reading: number, diff = 60) {
    // More than 10 seconds means inactive
    const diffMs = Math.abs(last_reading - Date.now()); // difference in milliseconds
    return !(diffMs > diff * 1000); // 10 seconds in ms
  }

  abstract searchParams(log: any, equipment_id: any);
}
